import { Filter } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function ColFilter({ label, id, value, onChange, options }) {
  return (
    <span className="inline-flex items-center gap-1">
      {label}
      <Popover>
        <PopoverTrigger asChild>
          <button type="button" aria-label={`Filter ${label}`} data-testid={`col-filter-${id}`}
            className={`relative p-1 rounded hover:bg-slate-100 transition-colors ${value ? "text-indigo-700" : "text-slate-400"}`}>
            <Filter className="w-3.5 h-3.5" />{value && <span className="absolute top-0.5 right-0.5 w-1.5 h-1.5 rounded-full bg-indigo-600" />}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-60 p-2 space-y-2" align="start">
          {options ? (
            <div className="flex flex-col">{[["", "All"], ...options].map(([v, l]) => (
              <button key={v || "all"} type="button" onClick={() => onChange(v)} data-testid={`col-filter-${id}-opt-${v || "all"}`}
                className={`text-left text-sm px-2 py-1.5 rounded ${value === v ? "bg-indigo-50 text-indigo-800 font-medium" : "hover:bg-slate-50"}`}>{l}</button>))}</div>
          ) : (
            <Input autoFocus value={value} onChange={(e) => onChange(e.target.value)} placeholder={`Filter ${label.toLowerCase()}`} className="h-8" data-testid={`col-filter-${id}-input`} />
          )}
          {value && <Button size="sm" variant="ghost" className="w-full h-7" onClick={() => onChange("")}>Clear</Button>}
        </PopoverContent>
      </Popover>
    </span>
  );
}
